import { useEffect, useState } from "react";
import { api, errMsg } from "../../../lib/api";

function Row({ k, v, testId }) {
  return <div className="flex justify-between py-1.5 border-b border-slate-800/70 text-sm"><span className="text-slate-400">{k}</span><span className="font-mono text-slate-200" data-testid={testId}>{v}</span></div>;
}

export function useCalc(bookId, f, refresh) {
  const [c, setC] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => api.post(`/books/${bookId}/print/calc`, f).then((r) => setC(r.data)).catch((e) => setC({ error: errMsg(e) })), 300);
    return () => clearTimeout(t);
  }, [bookId, JSON.stringify(f), refresh]); // eslint-disable-line
  return c;
}

export function CalcPanel({ c, edition }) {
  if (!c || c.error) return <div className="panel p-5 text-sm text-warn-300" data-testid={`${edition}-calc-error`}>{c?.error || "Loading layout maths…"}</div>;
  const cov = c.cover;
  return (
    <div className="panel p-5" data-testid={`${edition}-calc`}>
      <p className="eyebrow mb-3">Layout calculator {c.estimated && <span className="text-warn-300 normal-case">· page count estimated until you generate</span>}</p>
      <Row k="Pages" v={`${c.pages} (allowed ${c.page_limits[0]}–${c.page_limits[1]})`} testId={`${edition}-calc-pages`} />
      <Row k="Page size (with bleed if on)" v={`${c.page_size_in[0]}" × ${c.page_size_in[1]}"`} />
      <Row k="Inside margin (gutter)" v={`${c.gutter_in}"`} testId={`${edition}-calc-gutter`} />
      <Row k="Minimum outside margin" v={`${c.min_outside_in}"`} />
      <Row k="Spine width" v={`${c.spine_in}"`} testId={`${edition}-calc-spine`} />
      <Row k="Spine text" v={c.spine_text_allowed ? "allowed" : "too thin (<79 pages)"} />
      <Row k={edition === "hardcover" ? "Case-laminate cover" : "Wraparound cover"} v={`${cov.width_in}" × ${cov.height_in}"`} testId={`${edition}-calc-cover`} />
      {c.dust_jacket && <Row k="Dust jacket" v={`${c.dust_jacket.width_in}" × ${c.dust_jacket.height_in}" · ${c.dust_jacket.flap_in}" flaps`} testId="hardcover-calc-jacket" />}
    </div>
  );
}
